export const JP_TRIAL_APPLICATION_PATH = '/subscribes/jp/trial'
export const PAID_TRIAL_BOOKING_REFERRER = 'paid-trial'
